import React from 'react';
import { Link } from 'react-router-dom';

import { CircleAlert, CircleCheck, CircleX } from "lucide-react";

import { ISimulationReportV1 } from '../../../types/services.interface';

import { getScoreColor } from '../../../helpers/misc.helper';

interface AnalysisV1Props {
    report: ISimulationReportV1;
};
export const AnalysisV1 = ({ report }: AnalysisV1Props) => {

    return (
        <div className='analysis_v1'>
            <h3 className='analysis_v1__title'>Simulation Complete</h3>
            <p className='analysis_v1__subtitle'>Your Communication Analysis Report</p>
            <br /><br />
            <div className='analysis_v1__overall_communication_profile'>
                <h5>Overall Communication Profile</h5>
                <p className='analysis_v1__overall_communication_profile__content'>
                    {report.overall_communication_profile.content}
                </p>
                <p className={`analysis_v1__overall_communication_profile__status analysis_v1__overall_communication_profile__status__color_${report.overall_communication_profile.status}`}>
                    {report.overall_communication_profile.status[0].toUpperCase() + report.overall_communication_profile.status.slice(1)}
                </p>
            </div>
            <br />
            <div className='analysis_v1__communication_dimensions'>
                <h5>Communication Dimensions</h5>
                <div className='analysis_v1__communication_dimensions__list'>
                    {report.communication_dimensions.map((dimension) => (
                        <div
                            key={dimension.title}
                            className={`analysis_v1__communication_dimensions__item analysis_v1__communication_dimensions__item__color_${getScoreColor(dimension.score)}`}
                        >
                            <div className='analysis_v1__communication_dimensions__item__top'>
                                <div className='analysis_v1__communication_dimensions__item__top__content'>
                                    <h6>{dimension.title}</h6>
                                    <p>{dimension.description}</p>
                                </div>
                                <div className='analysis_v1__communication_dimensions__item__top__score'>
                                    {
                                        dimension.score < 3
                                            ? <CircleX />
                                            : dimension.score < 5
                                                ? <CircleAlert />
                                                : <CircleCheck />
                                    }
                                    <h4>{dimension.score}/5</h4>
                                </div>
                            </div>
                            <div className='analysis_v1__communication_dimensions__item__progress_bar'>
                                <div className='analysis_v1__communication_dimensions__item__progress_bar__fill' style={{ width: `${(dimension.score / 5) * 100}%` }} />
                            </div>
                            <p className='analysis_v1__communication_dimensions__item__report'>{dimension.report}</p>
                        </div>
                    ))}
                </div>
            </div>
            <br />
            <div className='analysis_v1__future_recommendations'>
                <h5 className='mb-xl'>Recommendations for Future Conversations</h5>
                {report.future_recommendations.map((recommendation, idx) => (
                    <div
                        key={recommendation}
                        className='analysis_v1__future_recommendations__item'
                    >
                        <div>{idx + 1}</div>
                        <p className='text-sm'>{recommendation}</p>
                    </div>
                ))}
            </div>
            <br />
            <div className='analysis_v1__reflection_questions'>
                <h5 className='mb-xl'>Reflection Questions</h5>
                {report.reflection_questions.map((question) => (
                    <div
                        key={question.question}
                        className='analysis_v1__reflection_questions__item'
                    >
                        <p className='text-sm'><strong>{question.question}</strong></p>
                        <p className='text-sm mt-xs'>{question.answer}</p>
                    </div>
                ))}
            </div>
            <br /><br />
            <div className='analysis_v1__new_simulation_link_wrapper'>
                <Link to='/'>Start New Simulation</Link>
            </div>
        </div>
    );
};